import { CssBaseline, ThemeProvider } from '@mui/material'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App'
import theme from './theme/theme'
import { UIProvider } from './context/UIContext'
import { queryClient } from './queries/config'
import { useCompanySpaces } from './queries/useCompanyQueries'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const AppWithThemeProvider = () => {
  const { data: companyData } = useCompanySpaces()

  return (
    <ThemeProvider theme={theme(companyData?.body?.content[0]?.color)}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  )
}

root.render(
  <QueryClientProvider client={queryClient}>
    <UIProvider>
      <AppWithThemeProvider />
    </UIProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
)
